import * as React from "react";

const IconCartRemoveHover: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#298CF0" d="M9.706 8.295a1 1 0 11-1.413 1.413L5 6.416 1.707 9.707a.991.991 0 01-.707.294 1 1 0 01-.707-1.708l3.294-3.294L.293 1.707A1 1 0 111.707.293L5 3.588 8.294.295a1 1 0 111.414 1.414L6.414 5.002l3.292 3.293z"/></svg>;
};

export default React.memo(IconCartRemoveHover);
